import { Component, computed, inject, input } from '@angular/core';
import { DashboardAlertComponent } from '@shared/components/dashboard-alert/dashboard-alert.component';
import { SectionsService } from '@app/shared/dasboard-sections/services/sections.service';
import { GenericApplicationSections } from '@shared/interfaces/agnostic-sections.type';

@Component({
  selector: 'app-section-lock-alert',
  standalone: true,
  imports: [DashboardAlertComponent],
  template: `
    @if (isLocked()) {
      <app-dashboard-alert
        className="mb-4"
        type="info"
        message="This section is locked. You can only view the information" />
    }
  `,
})
export class SectionLockAlertComponent {
  private readonly _sectionsService = inject(SectionsService);

  section = input.required<GenericApplicationSections>();

  constructor() {
    this._sectionsService.ensureLockedSectionsLoaded();
  }

  readonly isLocked = computed(() =>
    this.section
      ? this._sectionsService.isSectionLocked(this.section())
      : false,
  );
}
